module.exports = __webpack_public_path__ + "static/media/illus-heart-rect.02decdcb.png";